import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface Product {
  id: number
  name: string
  description: string
  price: string
  image1: string
  image2: string
  stripeLink: string
}

export default function Products() {
  const { t } = useTranslation()
  const [hoveredProduct, setHoveredProduct] = useState<number | null>(null)

  const products: Product[] = [
    {
      id: 1,
      name: t('products.product1.name'),
      description: t('products.product1.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-14.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-18.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 2,
      name: t('products.product2.name'),
      description: t('products.product2.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-15.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-19.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 3,
      name: t('products.product3.name'),
      description: t('products.product3.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-16.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-17.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 4,
      name: t('products.product4.name'),
      description: t('products.product4.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-2.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-1.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 5,
      name: t('products.product5.name'),
      description: t('products.product5.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-12.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-13.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 6,
      name: t('products.product6.name'),
      description: t('products.product6.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-10.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-11.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 7,
      name: t('products.product7.name'),
      description: t('products.product7.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-7.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-8.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 8,
      name: t('products.product8.name'),
      description: t('products.product8.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-6.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-9.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    },
    {
      id: 9,
      name: t('products.product9.name'),
      description: t('products.product9.description'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-5.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-11.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02"
    }
  ]

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-white to-[#FFDB58]/5">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-4">
            {t('products.sectionTitle')}
          </h2>
          <p className="text-base md:text-lg text-[#333333]/70 max-w-2xl mx-auto">
            {t('products.sectionSubtitle')}
          </p>
        </div>

        {/* Empty State - Uncomment this section if products array is empty */}
        {/* {products.length === 0 ? (
          <div className="text-center py-16 md:py-24">
            <div className="max-w-md mx-auto">
              <div className="mb-6 flex justify-center">
                <svg className="w-20 h-20 md:w-24 md:h-24 opacity-50 text-[#E2725B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#333333] mb-4">
                Products Coming Soon!
              </h3>
              <p className="text-base md:text-lg text-[#333333]/70 mb-8">
                We're carefully curating our premium tea collection. Check back soon for our exquisite blends!
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#E2725B] hover:bg-[#d65f48] text-white font-bold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <span>Get Notified</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </div>
        ) : ( */}

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {products.map((product) => {
            const showSecondImage = hoveredProduct === product.id
            
            return (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group border-2 border-[#FFDB58]/20 hover:border-[#E2725B]/40 flex flex-col h-full no-underline"
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                {/* Product Image Container */}
                <div 
                  className="relative h-64 sm:h-72 md:h-64 overflow-hidden bg-gray-100 flex-shrink-0"
                >
                  {/* Image 1 */}
                  <img
                    src={product.image1}
                    alt={product.name}
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                      showSecondImage ? 'opacity-0' : 'opacity-100'
                    }`}
                  />
                  {/* Image 2 (shows on hover/tap) */}
                  <img
                    src={product.image2}
                    alt={`${product.name} alternate view`}
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                      showSecondImage ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                  
                  {/* Price Badge - More prominent on mobile */}
                  <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-[#E2725B] text-white px-4 py-2 md:px-5 md:py-2.5 rounded-full shadow-xl font-bold text-lg md:text-xl">
                    {product.price}
                  </div>

                </div>

                {/* Product Info */}
                <div className="p-5 sm:p-6 flex flex-col flex-grow">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#333333] mb-2 sm:mb-3 leading-tight">
                    {product.name}
                  </h3>
                  <p className="text-sm sm:text-base text-[#333333]/70 mb-5 sm:mb-6 leading-relaxed flex-grow">
                    {product.description}
                  </p>

                  {/* View Details Indicator */}
                  <div className="group/btn w-full min-h-[48px] px-5 py-3.5 sm:px-6 sm:py-4 bg-[#4D5D33] text-white text-base sm:text-lg font-bold rounded-xl transition-all duration-300 ease-out flex items-center justify-center shadow-lg pointer-events-none">
                    <svg 
                      className="w-5 h-5 sm:w-6 sm:h-6 mr-2" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                    <span className="font-extrabold tracking-wide">{t('products.viewDetails')}</span>
                    <svg 
                      className="w-4 h-4 sm:w-5 sm:h-5 ml-2" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            )
          })}
        </div>

        {/* End of conditional rendering - Uncomment closing parenthesis if using empty state */}
        {/* )} */}

        {/* Bottom CTA */}
        <div className="mt-12 sm:mt-16 text-center px-4">
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-white px-4 sm:px-6 py-3 sm:py-4 rounded-full shadow-lg border-2 border-[#FFDB58]/30">
            <svg className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 text-[#FFDB58]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            <p className="text-[#333333] font-semibold text-sm sm:text-base">
              {t('products.freeShipping')}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

